<template>
  <div>
    <Head title="Import Block CSV" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/blocks/uncut">Uncut Blocks</Link>
      <span class="text-orange-400 font-medium">/</span> Import Block CSV
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store" enctype="multipart/form-data">
        <div class="flex flex-wrap mb-2 -mr-6 p-8">
          <file-input v-model="form.block_file" :error="form.errors.block_file" class="pb-1 pr-6 w-full lg:w-4/4" type="file" accept="text/csv" label="Block CSV File" />
          <div v-if="$page.props.errors" class="form-error mb-2">{{ $page.props.errors.block_file }}</div>
          <small class="form-text mt-1">
            <i>
              <strong>
                The CSV file must have the header as the first row in the format: production_date, block_id, block_category, block_type, dimension, block_weight and status.
              </strong>
            </i>
          </small>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-orange px-3 py-2 text-xs"
            type="submit"
          >
            Import CSV
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  props: {},
  data() {
    return {
      form: this.$inertia.form({
        block_file: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/blocks/import', {
        onSuccess: () => {
          this.form.reset(
            'block_file'
          )
        }
      })
    },
  },
}
</script>
